import React, { useContext, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Button } from 'reactstrap'
import _ from "lodash"
import { useSelector } from "react-redux"
//************************************//
import { ButtonSpinner } from '@src/components'
//************************************//
const DeleteModal = (props) => {
	//************************************//
	const loading = useSelector(store => store.app.loading)
	//************************************//
	const _close = () => {
		props.onClose()
	}
	//************************************//
	const onSubmit = async () => {
		await props.onDelete()
		_close()
	}
	//************************************//
	return (
		<Modal
			isOpen={true}
			// toggle={_close}
			unmountOnClose={true}
			backdrop={true}
			className='modal-dialog-centered modal-md'
		>
			<ModalBody>
				<div className={'d-flex flex-column'}>
					<h3>{_.get(props, 'data.title')}</h3>
					<span>{_.get(props, 'data.text')}</span>
					<span className={'mt-50'}>{_.get(props, 'data.subText')}</span>
				</div>
			</ModalBody>
			<ModalFooter>
				<Button color={'flat-secondary'} onClick={_close} disabled={loading}>
					{
						_.get(props, 'data.denyButtonText', 'No')
					}
				</Button>
				<Button color={'danger'} onClick={onSubmit} disabled={loading}>
					{loading && <ButtonSpinner />}
					{
						_.get(props, 'data.confirmButtonText')
					}
				</Button>
			</ModalFooter>
		</Modal>
	)
}
//************************************//
export default DeleteModal

